import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import React from 'react';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: {
      "titleappname": "Simply Flows - ",
      "errormsggeneric": (<>Oh snap!<br /><br />Our team has been notified and is working on a solution.<br /><br />In the meantime, you can go to our <a href="https://simplyflows.com" target="_blank" rel="noopener noreferrer">homepage</a>.<br /><br />We appreciate your patience!"</>),
      "errormsgformsubmission": "Oh snap! Loading didn't go as expected. Please try again or go back and try with different values.",
      "msg_retry": "Looks like it's still not working... Please contact us for further assistance.",
      "appaddedsuccess": "Application successfully added",
      "loading": "Loading...",
      "no_results": "No results found",
      "btntryagain": "Try Again",
      "btnclear": "Clear",
      "btncontinue": "Continue",
      "btnclose": "Close",
      "btndeleteconfirm": "Delete",
      "btn_confirm": "Confirm",
      "btnrefresh": "Refresh",
      "lbl_warning": "Warning",
      "descairtableapikey": (<> API key <span className="font-italic">(required)</span><br />You can find your API key (or generate a new one) on your <a href="https://airtable.com/account" target="_blank" rel="noopener noreferrer">account page</a>.</>),
      "descalphavantageapikey": (<> API key <span className="font-italic">(required)</span><br />You can get a free key <a href="https://www.alphavantage.co/support/#api-key" target="_blank" rel="noopener noreferrer">here</a>.</>),
      "descairtableappid": (<> App ID <span className="font-italic">(optional)</span><br />You can find the App ID by following <a href="https://airtable.com/api" target="_blank" rel="noopener noreferrer">this link</a> and selecting the base. Then look at the URL to find the App ID part in it, the part that starts with "app". For example, if the URL is https://airtable.com/<b>appPqRsgYQmpJ4wRQ</b>/api/docs#curl/introduction, the App ID is appPqRsgYQmpJ4wRQ. </>),
      "descsendgridapikey": (<> API key <span className="font-italic">(required)</span><br />You can find your API key (or generate a new one) <a href="https://app.sendgrid.com/guide/integrate/langs/nodejs" target="_blank" rel="noopener noreferrer">here</a>.</>),
      "desc_twilio_account_SID": (<> Account SID <span className="font-italic">(required)</span><br />You can find your account SID and auth token <a href="https://www.twilio.com/console" target="_blank" rel="noopener noreferrer">here</a>.</>),
      "desc_twilio_auth_token": (<> Auth token <span className="font-italic">(required)</span></>),
      "desc_twilio_name": "Name",
      "desc_twilio_phone": (<>Phone number. You can find your number <a href="https://www.twilio.com/console/phone-numbers/incoming" target="_blank" rel="noopener noreferrer">here</a>.</>),
      "desctogglapitoken": (<> API token <span className="font-italic">(required)</span><br />You can find your API token (or generate a new one) here: <a href="https://track.toggl.com/profile" target="_blank" rel="noopener noreferrer">https://track.toggl.com/profile</a>. Scroll down to the 'API Token' section.</>),
      "descairtablename": "Name",
      "desc_cryptowatch_apikey": (<> API key <span className="font-italic">(required)</span><br />You can find your API key (or generate a new one) on your <a href="https://cryptowat.ch/account/api-access" target="_blank" rel="noopener noreferrer">account - API Access</a> page.</>),
      "desc_cryptowatch_name": "Name",
      "desc_finnhub_apikey": (<> API key <span className="font-italic">(required)</span><br />You can find your API key (or generate a new one) on your <a href="https://finnhub.io/dashboard" target="_blank" rel="noopener noreferrer">dashboard</a> page.</>),
      "desc_finnhub_name": "Name",
      "desc_sendinblue_apikey": (<> The API key can be retrieved from the <a href="https://account.sendinblue.com/advanced/api" target="_blank" rel="noopener noreferrer">account settings</a>. Make sure to get the key for the version of the API you're using.</>),
      "desc_sendinblue_name": "Name",
      "errormessagetryagain": "Oh snap! Loading didn't go as expected. Please try again or go back and try with different values.",
      "errormessageempty": "Oh snap! Please check if these items exist in your application and add at least one if they don't.",
      "titlefindworkflow": "Find a Workflow Template",
      "descfindworkflow": "Check out our template gallery with ready-made workflows. You can tweak the templates and save them as your own. You may create a workflow from scratch as well.",
      "lblfrom": "From",
      "lblto": "To",
      "lblrole": "Role",
      "lblindustry": "Industry",
      "lblsendgridfromemail": "From email address",
      "lblneedsattention": "The workflow needs attention",
      "lbllastrunfail": "Last run failed",
      "lbllastrunsucceed": "Last run succeeded",
      "lblflownextrun": "Next run: ",
      "lblflowlastrun": "Last run: ",
      "lblflowdelete": "Delete Confirmation",
      "lblflowdeleteconfirm": "Are you sure you want to delete this workflow?",
      "lblappdeleteconfirm": "Are you sure you want to delete the connection to this application? Please be advised that this will stop execution of workflows using this app. If you add a new connection, please update your workflows and turn them on again.",
      "lbltemplatedeleteconfirm": "Are you sure you want to delete the template?",
      "lbldeleteconfirm": "Delete Confirmation",
      "lblblockdeleteconfirm": "Are you sure you want to delete this block?",
      "btndelete": "Delete",

      "airtable": "Airtable",
      "alphavantage": "Alpha Vantage",
      "asana": "Asana",
      "defipulse": "DeFi Pulse",
      "docusign": "DocuSign",
      "facebook": "Facebook Leads Ad",
      "finnhub": "Finnhub",
      "sendinblue": "Sendinblue",
      "googlegmail": "Gmail",
      "google": "Google",
      "googlecalendar": "Google Calendar",
      "googledrive": "Google Drive",
      "googleforms": "Google Forms",
      "googlesheets": "Google Sheets",
      "hubspot": "HubSpot",
      "linkedin": "LinkedIn",
      "mailchimp": "Mailchimp",
      "microsoft": "Microsoft",
      "msteams": "Teams",
      "onedrive": "OneDrive",
      "salesforce": "Salesforce",
      "sendgrid": "SendGrid",
      "shopify": "Shopify",
      "simplyflows_crypto": "Crypto",
      "simplyflows_sms": "SMS",
      "simplyflows_convert": "Convert",
      "simplyflows_delay": "Delay",
      "simplyflows_filter": "Filter",
      "simplyflows_finance": "Finance",
      "simplyflows_foreach": "For Each",
      "simplyflows_input": "Start",
      "simplyflows_merge": "Merge",
      "simplyflows_pause": "Pause",
      "simplyflows_stop": "Stop",
      "simplyflows_sendemail": "Email",
      "slack": "Slack",
      "smartsheet": "Smartsheet",
      "toggltrack": "Toggl Track",
      "trello": "Trello",
      "twilio": "Twilio",
      "twitter": "Twitter",
      "wordpress": "WordPress",

      "accountant": "Accountant",
      "administrativeassistant": "Administrative Assistant",
      "businessanalyst": "Business Analyst",
      "businessdevelopmentprofessional": "Business Development Professional",
      "businessownerorfounder": "Business Owner or Founder",
      "customersupportrepresentative": "Customer Support Representative",
      "datascientistanalystengineer": "Data Scientist/Analyst/Engineer",
      "designer": "Designer",
      "devopsengineer": "DevOps Engineer",
      "facilitiespropertymanager": "Facilities/Property Manager",
      "financialadvisor": "Financial Advisor",
      "fitnesscoach": "Fitness Coach",
      "healthprofessional": "Health Professional",
      "hrprofessional": "HR Professional",
      "itprofessional": "IT Professional",
      "legalprofessional": "Legal Professional",
      "marketingspecialist": "Marketing Specialist",
      "officemanager": "Office Manager",
      "operationsprofessional": "Operations Professional",
      "presidentorceo": "President or CEO",
      "productmanager": "Product Manager",
      "projectmanager": "Project Manager",
      "prprofessional": "PR Professional",
      "realestateagent": "Real Estate Agent",
      "salesperson": "Salesperson",
      "schooladministrator": "School Administrator",
      "softwarewebmobileengineer": "Software/Web/Mobile Engineer",
      "student": "Student",
      "teacherorprofessor": "Teacher or Professor",
      "writeroreditor": "Writer or Editor",

      "administrativeandsupport": "Administrative and Support",
      "advertising": "Advertising",
      "agricultureandforestry": "Agriculture and Forestry",
      "apparel": "Apparel",
      "architecture": "Architecture",
      "automotive": "Automotive",
      "biotechnology": "Biotechnology",
      "commercialservices": "Commercial Services",
      "construction": "Construction",
      "consumergoods": "Consumer Goods",
      "consulting": "Consulting",
      "cosmetics": "Cosmetics",
      "design": "Design",
      "education": "Education",
      "financeandbanking": "Finance and Banking",
      "foodandbeverages": "Food and Beverages",
      "governmentandpublicservice": "Government and Public Service",
      "healthcare": "Healthcare",
      "hotelsandrestaurants": "Hotels and Restaurants",
      "hrandemploymentservices": "HR and Employment Services",
      "insurance": "Insurance",
      "leisureandsports": "Leisure and Sports",
      "logistics": "Logistics",
      "management": "Management",
      "manufacturing": "Manufacturing",
      "publishingandbroadcasting": "Publishing and Broadcasting",
      "realestate": "Real Estate",
      "researchservices": "Research Services",
      "retailandecommerce": "Retail and E-commerce",
      "technology": "Technology",
      "telecommunications": "Telecommunications",
      "transportation": "Transportation",
      "utilities": "Utilities",

      "lbl_password": "Password",
      "val_password": "Password must be 8 characters long and include: a number, a lowercase letter, and an uppercase letter.",
      "tip_password": "Type your password",

      "lbl_email": "Email",
      "lbl_new_email": "New email",
      "tip_email": "Type your email",

      "lbl_phone": "Phone number",
      "tip_phone": "Type your phone number",

      "lbl_name": "Name",
      "tip_given_name": "First name",
      "tip_family_name": "Last name",

      "btn_signup": "Sign up",
      "title_page_signup": "Sign up",
      "title_signup": "Create your free account",
      "desc_signup": "100% free. No credit card needed.",
      "account_terms": (<>By creating an account, you agree to our <a href="https://simplyflows.com/terms/" target="_blank">Terms</a> and <a href="https://simplyflows.com/privacy-policy/" target="_blank">Privacy</a> policies.</>),
      "account_created": (<>Welcome to Simply Flows! One last step - verify your account, please, by providing the code we've emailed you. <br />We connect your applications and streamline your processes, so you can focus on what matters most.</>),
      "lbl_marketing_email": "I would like to receive occasional emails with new features and tips.",

      "btn_signout": "Sign out",
      "title_signout": "Sign out",


      "title_rewards": "My Rewards",

      "title_office": "Office",

      "title_login": "User Login",
      "btn_login": "Log in",
      "btn_forgotten_password": "Forgotten Password",
      "btn_account_confirm": "Confirm Account",
      "forgotten_password_email_sent": "You should have received an email with a verification code. Please enter that code in the field bellow.",

      "title_verify_email": "Email Validation",
      "title_verify_phone": "Phone Number Validation",

      "title_profile": "My Profile",
      "btn_profile_update": "Update",
      "lbl_profile_welcome": "We'd like to learn a bit more about you, so we can better customize your experience.",
      "lbl_timezone": "Timezone",
      "warning_email_change": "You've updated your email. Verification of the new email will be required.",
      "warning_phone_change": "You've updated your phone. Verification of the new phone will be required.",
      "btn_change_password": "Change Password",

      "title_forgotten_password": "Forgotten Password",
      "title_confirm_registration": "Confirm Registration",
      "lbl_code": "Code",
      "val_code": "The code should have exactly 6 digits.",
      "tip_code": "Type the code from the email we sent you.",
      "tip_code_phone": "Type the code from the SMS we sent you.",
      "btn_confirmation_submit": "Submit",
      "btn_confirmation_send": "Send Code",
      "btn_confirmation_resend": "Resend Code",
      "btn_confirmation_resending": "Resending...",
      "lbl_resubmit_code": "You may request a new code to be sent to you.",
      "btn_validate_phone": "Validate Phone",

      "lbl_old_password": "Old Password",
      "lbl_new_password": "New Password",
      "btn_changepassword_submit": "Submit",
      "changepassword_different": "Please enter a different new password.",

      "UserNotFoundException": "We couldn't find such user. Please check the spelling of your email.",

      "title_error": "Error",
      "title_templates": "Templates",
      "title_workflow": "Workflow",
      "title_myworkflows": "My Workflows",
      "title_apps": "Applications",
      "title_search": "Search",
      "title_search_workflow": "Search for workflows/templates",

      "warning_search_no_results": "Hmm, no results found. Try searching for something else, please.",

      "lbl_example_value": "An example value: ",

      "lbl_success": "Yay, success!",
      "lbl_error": "Snap, there was an error...",
      "lbl_required": "Please fill in the required field(s).",

      "lbl_select_application": "Application",
      "lbl_placeholder_application": "Select or type the application name",
      "lbl_select_block": "Action",
      "lbl_placeholder_action": "Select or type the action name",
      "lbl_select_account": "Account",
      "btn_done": "Done",

      "tip_workflow_title": "Add a name for your workflow here.",
      "tip_block_setup": "Set up block",
      "tip_block_add": "Add block",
      "tip_block_insert": "Insert block",
      "tip_block_connect": "Connect blocks",
      "tip_block_merge": "Merge blocks",
      "tip_block_warning": "Setup not complete or test not successful.",
      "btn_test": "Test",
      "lbl_test": "Test connection to the selected application with the account & parameters provided.",

      "tip_add_item": "Add item",
      "tip_field_remove": "Remove item",
      "tip_remove_item": "Remove item",

      "txt_merge_drop": "Drag and drop fields here to add them to the merged data.",
      "account_new": "Add a new account",
      "lbl_fieldinuse": "This field is used by another block of this workflow. If you do wish to delete it, please, remove it from the next block first and then from this one.",
      "disconnect_warning": "Please be advised that disconnecting will delete connection info to this app, which, in turn, will stop execution of workflows using this app. Once you reconnect (with the same or another account), your workflows will resume running.",
      "warning": "Warning",

      "template_warning": "Please be aware that saving this workflow as a template will remove any parameters or connections entered.",

      "lbl_convert_to_bool": "Please specify the text representation.",
      "lbl_convert_to_text": "Please specify the format.",
      "tip_field_select": "Select field",
      "tip_field_add": "Add field",
      "tip_field_remove": "Remove field",

      "title_change_action_confirm": "Confirm Change",
      "text_change_action_confirm": "Changing an application or an action will reset all subsequent blocks.",
      "btn_change_action_confirm": "Confirm",

      "stop_workflow_warning": "Please note that this will cancel all future executions of this workflow.",
      "disabled_play": "Manual run is only enabled for scheduled workflows.",

      "lblsharedeleteconfirm": "Are you sure you want to delete the share? The user will not be able to access the workflow.",
      "tip_share_email": "Add email of the person you want to invite",
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",

    keySeparator: false, // we do not use keys in form messages.welcome

    returnObjects: false,
    returnedObjectHandler: (key, value, options) => value,

    interpolation: {

      escapeValue: false // react already safes from xss
    }
  });

export default i18n;